import React from "react";

export interface InputDateTimeLocalProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  value?: string;
}

export function InputDateTimeLocal(props: InputDateTimeLocalProps) {
  return (
    <input
      {...props}
      type="datetime-local"
      className="w-full border border-gray-300 rounded py-2 px-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:text-gray-600 disabled:cursor-not-allowed disabled:bg-gray-100"
    />
  );
}
